import { Classification } from './classification.model';

export interface ProjectListItem {
  id: number;
  applicationId: number;
  isValid?: boolean;
  name?: string;
  description?: string;
  dateCompleted?: Date;
  projectTypeId?: number;
  projectType?: string;
  projectValue?: number;
  isMostValuable?: boolean;
  active?: boolean;
}

export interface Project {
  id: number;
  applicationId: number;
  isValid: boolean;
  name?: string;
  description?: string;
  scheduledCompletionDate?: Date;
  dateCompleted?: Date;
  city?: string;
  stateId?: number;
  isPrimeContractor?: boolean;
  licenseClassifications?: Classification[];
  bidNumber?: string;
  permitNumber?: string;
  projectTypeId?: number;
  deliveryMethodId?: number;
  deliveryMethodOther?: string;
  hasOwnerContract?: boolean;
  originalProjectValue?: number;
  projectValue?: number;
  cmName?: string;
  cmLastName?: string;
  cmPhone?: string;
  cmEmail?: string;
  ownerFirmName?: string;
  ownerContactName?: string;
  ownerContactLastName?: string;
  ownerContactPhone?: string;
  ownerContactEmail?: string;
  designContactName?: string;
  designContactLastName?: string;
  designContactPhone?: string;
  designContactEmail?: string;
  inspectorContactName?: string;
  inspectorContactLastName?: string;
  inspectorContactPhone?: string;
  inspectorContactEmail?: string;
  otherContactName?: string;
  otherContactLastName?: string;
  otherContactPosition?: string;
  otherContactPhone?: string;
  otherContactEmail?: string;
  originalProjectId?: number;
}

export interface ProjectDataItem {
  projectId: number;
  isValid: boolean;
}

export interface ProjectNote {
  projectNotes: string;
}

export interface QBATProjectResponse {
  project: Project;
  projectChanges: string[];
}
export interface ProjectInterviewContact {
  fullName: string;
  email: string;
  phone: string;
  projectName: string;
  position: string;
}

export interface ProjectInterview {
  id: number;
  projectId: number;
  token: string;
  fullName: string;
  email: string;
  phone: string;
  status: ProjectInterviewStatus;
  position: string;
  projectName: string;
  surveyId: number;
  surveyBody?: string;
  surveyTotal?: number;
  surveyTotalOf?: number;
  surveyComments?: string;
  surveyDistrictNotes?: string;
  dateSent: Date;
  sentByName: string;
  sentCount: number;
  interviewRequestPending: boolean;
}

export enum ProjectInterviewStatus {
  open = 'Open',
  closed = 'Closed',
  completed = 'Completed',
  forwarded = 'Forwarded',
}

export interface ProjectInterviewLog {
  id: number;
  username: string;
  message: string;
  createdDate: Date;
}

export interface ProjectInterviewSurveyQuestionResponse {
  id: number;
  isRequired: boolean;
  isTallied: boolean;
  questionOrder: number;
  questionText: string;
  questionTypeId: ProjectInterviewSurveyQuestionType;
  surveyId: number;
}

export class ProjectInterviewSurveyQuestion {
  get Type(): string {
    return ProjectInterviewSurveyQuestionType[this.type];
  }

  get Number(): number {
    return this.order;
  }

  Touch(): void {
    this.dirty = true;
  }

  public Value: any;
  private dirty: boolean = false;

  constructor(
    public id: number,
    public version: number,
    public text: string,
    public type: ProjectInterviewSurveyQuestionType,
    public settings: { min: number; max: number },
    public order: number,
    public required: boolean,
    public tallied: boolean
  ) {
    this.Value = '';
  }

  IsRequired(): boolean {
    return this.required;
  }

  IsTallied(): boolean {
    return this.tallied;
  }

  IsValid(): boolean {
    if (this.type === ProjectInterviewSurveyQuestionType.Scale) {
      if (this.dirty && this.Value === '') {
        return false;
      }
    } else if (this.required && this.Value === '') {
      return false;
    }

    return true;
  }
}

export enum ProjectInterviewSurveyQuestionType {
  Scale = 0,
  Input,
  TextArea,
}

export interface ProjectInfo {
  id: number;
  projectName: string;
  value: number;
  openInterviews: number;
  completedInterviews: number;
  average: number;
  projectType?: string;
  isValid?: boolean;
  isMostValuable?: boolean;
}
